import { Box, Chip } from '@material-ui/core'
import { last } from 'lodash'
import { useState, useEffect } from 'react'
import AmsChip from '../../atoms/AmsChip/AmsChip'
import AmsProductCount from '../../atoms/AmsProductCount/AmsProductCount'
import { addItemToInventory, addItemToRooms } from '../../utils/helpers'
import './anotherItemList.css'


const AnotherItemList = (props: any) => {

    const { list,roomType } = props

    
    const [listItems, setListItems] = useState<any>(list || [])
    const [selectedProduct, setSelectedProduct] = useState<any[]>([])


    // const updateRoomInfo = (allRooms:any,selectedRoom:any,roomType:any) => {
    //     // Find the "Bedroom" object in myArr
    //     const roomObject = allRooms.find((obj:any) => obj.hasOwnProperty(`${roomType}`));

    //     if (roomObject) {
    //         // Update the "Bedroom" array in bedroomObject
    //         roomObject[`${roomType}`].forEach((roomItem:any, index:any) => {
    //             const matchingNewItem = selectedRoom.find((newItem:any) => newItem.index === roomItem.index);
    //             if (matchingNewItem) {
    //                 roomObject[`${roomType}`][index] = matchingNewItem;
    //             }
    //         });
    //     }

    //     console.log("Room Object is:",roomObject,allRooms)

    //     return allRooms
    // }

    useEffect(() => {
       const newArr = [...selectedProduct,...listItems]
       let roomInfo:any = sessionStorage.getItem(`roomInfo`)
        
        if(roomInfo){
            roomInfo = JSON.parse(roomInfo);
            //const newRoomInfo = updateRoomInfo(roomInfo,newArr,roomType)
           //sessionStorage.setItem("roomInfo", JSON.stringify(newRoomInfo))
        }  
    },[selectedProduct])
  
    const handleItemClick = (index:number) => {
        let listArr = [...listItems]
        let product = listArr.filter((item)=> item?.index === index)[0]
   
        product['quantity'] = 1;
        listArr = listArr.filter((item)=> item?.index !== index)
        setListItems([...listArr])
        setSelectedProduct(selectedProduct => [...selectedProduct,product]);

        //Adding the product in inventory List to show on inventory page
        addItemToInventory(product)
        addItemToRooms(product)

    }

    const handleDecrement = (index:any, count:any,product:any) => {
   
       addItemToInventory(product)
       addItemToRooms(product)
        let productList:any = [...selectedProduct];
        if(count > 1){      
            productList.map((item:any) => {
                if(item?.index === index){
                    item['quantity'] = item['quantity']-1;
                }
            })
            setSelectedProduct(productList)
        }else{
             //adding the element removed from selected product into the list item again
             let lastCount = productList.filter((item:any) => item?.index === index)[0]
             lastCount['quantity'] = 0;
             let newList = [...listItems];
             newList.push(lastCount);
             setListItems(newList)
            //removing the element from selected product list when it's count is 0
            let newProduct = [...productList]
            newProduct = newProduct.filter((item:any) => item?.quantity !==0);
            setSelectedProduct(newProduct);
        }

    }

    const handleIncrement = (index:any,count:any,product:any) => {
        
        let productList = [...selectedProduct];
        productList.map((item:any) => {
            if(item?.index === index){
                item['quantity'] = item['quantity']+1;
            }
        })
        setSelectedProduct(productList)
        addItemToInventory(product)
        addItemToRooms(product)
    }

  

    return (
        <Box className='productList'>
             <Box  mb={5} mt={5} className="listItems">
                {listItems.length > 0 && listItems?.map((item:any, index:any) => {
                    return (
                        <AmsChip className="singleProduct" itemClick={()=>handleItemClick(item?.index)} text={item?.text} key={index}/>
                    )
                }) }
               
            </Box>

            <Box mb={5} mt={5} className="product">
                {selectedProduct?.map((item:any, index:any) => {
                    return (
                        <AmsProductCount count={item?.quantity} onDecrementClick={() => handleDecrement(item?.index,item?.quantity,item)} onIncrementClick={() => handleIncrement(item?.index,item?.quantity,item)} className="singleProductCount" text={item?.text} index={item?.index} key={index} />
                    )
                }) }
               
            </Box>
        </Box>
    )
}

export default AnotherItemList